import _ from 'lodash';
import * as diffUtils from './diffUtils';

const CONTENDER_CHANGE_FIELDS = {
  'EndringsStatus': 'Uendret',
  'Tidligere_AktivPaamelding': '#N/A'
};

/*
* Team Members
*/
export function changesToContenders(detailsDiff, previousData) {
  let result = [];
  _.forEach(detailsDiff, (value, key) => {
    let changed_object = null;
    if (diffUtils.isNew(value)) {
      changed_object = addNew(value);
    } else if (diffUtils.isDeleted(value)) {
      changed_object = addDeleted(value);
    } else if (diffUtils.hasChanged(value)) {
      let item = previousData[Number(key)];
      changed_object = addChanges(item, value);
    } else {
      return;
    }
    result.push(changed_object);
  });
  return result;
}

export function addDeleted(changes) {
  return {
    ...changes[0],
    ...CONTENDER_CHANGE_FIELDS,
    EndringsStatus: 'Slettet',
  };
}

export function addNew(changes) {
  return {
    ...changes[0],
    ...CONTENDER_CHANGE_FIELDS,
    EndringsStatus: 'Ny',
  };
}

function updateTeam(item, changes) {
  _.forEach(changes, (change, key) => {
    item['Tidligere_' + key] = item[key];
    item[key] = change[0];
  });
  return item;
}

export function addChanges(item, changes) {
  if (!item) {
    return;
  }
  let result = {
    ...item,
    ...CONTENDER_CHANGE_FIELDS,
    EndringsStatus: 'Endret'
  };
  result = updateTeam(result, changes);
  return result;
}



/** WEBPACK FOOTER **
 ** ./src/containers/events/reports/sql/contendersDiff.js
 **/